export const PHYSICAL = 1;
export const ECOMMERCE = 2;
